import { JsonSchemaValidator } from "@common/json-schema-validator";
import { brandEntityRaw } from "../../schema";
import { BrandEntityRaw } from "../../interface";
import { BaseEntity } from "../base.entity";

export class BrandEntity extends BaseEntity<BrandEntityRaw> {
  private static validation = JsonSchemaValidator.compile(brandEntityRaw);

  constructor(value: BrandEntityRaw) {
    super(JsonSchemaValidator.assert(BrandEntity.validation, value));
  }
}
